module.exports = __webpack_public_path__ + "static/img/inis2.dba9e7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/inis2.png
// module id = jt/x
// module chunks = 1